import { makeStyles } from 'tss-react/mui';
import get from 'lodash/get';

export const useStyles = makeStyles<{
  height?: number | string;
  color?: string;
  transparentBackground?: boolean;
}>()((theme, { height, color, transparentBackground }) => {
  const barColor = color
    ? get(theme.tokens.colors, color) || color
    : theme.tokens.colors.original.brand.primary;

  return {
    root: {
      backgroundColor: transparentBackground
        ? 'transparent'
        : `${theme.tokens.colors.stroke.primary}`,
      borderRadius: theme.tokens.radius.m,
      ...(height &&
        typeof height === 'number' && { height: `${theme.px(height)}px` }),
      '& .MuiLinearProgress-bar': {
        borderRadius: theme.tokens.radius.m,
        backgroundColor: `${barColor}`,
      },
    },
  };
});
